import React from "react";
import WeddingMap from "../Parent/WeddingMap";
import { LinearGradient } from "react-text-gradients";
import InstaStory from "./InstaStory";
import InstaFeed from "./InstaFeed";
import InstagramGrid from "./InstaGrid";
import InstaDM from "./InstaDM";
import InstaLocation from "./InstaLocation";

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { WeddingInfo } from "../WeddingInfo/WeddingInfo";
import useBackgroundMusic from "../Common/useBackgroundMusic";
import { FaVolumeHigh, FaVolumeXmark } from "react-icons/fa6";
import WeddingCalendar from "../Common/WeddingCalendar";

const SplashScreen = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <img
        src={`${process.env.PUBLIC_URL}/instagram.webp`}
        alt="Metflix Logo"
        className="w-40 h-auto"
      />
      <div className="font-instagram-logo text-xl">
        <LinearGradient gradient={["to left", "#f9ce34, #ee2a7b ,#6228d7"]}>
          Marriagegram
        </LinearGradient>
      </div>
    </div>
  );
};

const InstagramScreen = () => {
  const { id } = useParams();
  const info = WeddingInfo.getInfo(id);
  const [isLoading, setIsLoading] = useState(true);
  const bgmSongName =
    window.location.hostname == "xn--vj5bwo95cw9x.com"
      ? "everything.mp3"
      : "wedding-sample-music.mp3";
  const { isMuted, toggleMute } = useBackgroundMusic(
    `${process.env.PUBLIC_URL}/${bgmSongName}`
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <SplashScreen />;
  }
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <meta name="theme-color" content="#ffffff" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#ffffff" />

      {/* 메인 컨텐츠 */}
      <div className="w-full max-w-md bg-white p-0 text-center mb-12">
        <div className="w-full max-w-md bg-white p-0 text-center mb-12 relative">
          {/* 🔊 뮤트 버튼 */}
          <button
            onClick={toggleMute}
            className="absolute top-4 right-4 z-50 bg-black bg-opacity-80 hover:bg-opacity-100 transition p-2 rounded-full"
          >
            {isMuted ? (
              <FaVolumeXmark className="text-white w-5 h-5" />
            ) : (
              <FaVolumeHigh className="text-white w-5 h-5" />
            )}
          </button>

          {/* 메인 콘텐츠 내용들 */}
        </div>

        <div className="font-instagram-logo text-xl text-left mt-4 ml-4">
          <LinearGradient gradient={["to left", "#f9ce34, #ee2a7b ,#6228d7"]}>
            Marriagegram
          </LinearGradient>
        </div>
        <InstaStory images={info.instagram.storyImages} />

        <div className="space-y-6 p-0">
          {info.instagram.postInfos.map((post, index) => (
            <InstaFeed
              key={index}
              profileImage={post.profileImage}
              username={post.name}
              images={post.postImages}
              caption={post.title}
              captionDetail={post.caption}
              swiperId={`swiper${index + 1}`}
            />
          ))}
        </div>

        <InstagramGrid {...info.instagram.gridInfo} />

        {/* Location */}
        <InstaLocation
          instaLocation={info.common.addressInfo}
          weddingDate={info.common.weddingDateKR}
        />

        <WeddingCalendar
          weddingDateKR={info.common.weddingDateKR}
          weddingDate={info.common.weddingDate}
          backgroundColor="bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7]"
          gradient={["to left", "#f9ce34, #ee2a7b ,#6228d7"]}
        />

        <InstaDM accountInfos={info.common.accountInfos} />
      </div>
    </div>
  );
};

export default InstagramScreen;
